/* ============================================
   FILTROUS — Collection Page JavaScript
   ============================================
   Handles:
   - Sort dropdown → URL update
   - Grid/List view toggle (persists to localStorage)
   - Load More pagination (fetch + append)
   - Image hover swap (CSS-driven, JS fallback for touch)
   ============================================ */

(function () {
  'use strict';

  var STORAGE_KEY = 'filtrous_view_pref';

  // ── Sort Dropdown ──
  document.querySelectorAll('[data-sort-select]').forEach(function (select) {
    select.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', this.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  });


  // ── View Toggle (Grid / List) ──
  var grid = document.querySelector('[data-product-grid]');
  var viewBtns = document.querySelectorAll('[data-view]');

  if (grid && viewBtns.length) {
    // Restore saved preference
    var saved = localStorage.getItem(STORAGE_KEY);
    if (saved === 'list' || saved === 'grid') {
      setView(saved);
    }

    viewBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var view = this.dataset.view;
        setView(view);
        localStorage.setItem(STORAGE_KEY, view);
      });
    });
  }

  function setView(view) {
    if (!grid) return;

    if (view === 'list') {
      grid.classList.add('fcg__grid--list');
    } else {
      grid.classList.remove('fcg__grid--list');
    }

    viewBtns.forEach(function (btn) {
      var isActive = btn.dataset.view === view;
      btn.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });
  }


  // ── Load More Pagination ──
  var loadMoreBtn = document.querySelector('[data-load-more]');

  if (loadMoreBtn) {
    loadMoreBtn.addEventListener('click', function () {
      var btn = this;
      var nextUrl = btn.dataset.nextUrl;
      if (!nextUrl) return;

      btn.classList.add('fcg__load-more--loading');
      btn.textContent = 'Loading...';

      fetch(nextUrl)
        .then(function (res) { return res.text(); })
        .then(function (html) {
          var parser = new DOMParser();
          var doc = parser.parseFromString(html, 'text/html');

          // Extract new product cards
          var newCards = doc.querySelectorAll('[data-product-grid] > .fn-card');
          var currentGrid = document.querySelector('[data-product-grid]');

          newCards.forEach(function (card) {
            currentGrid.appendChild(card.cloneNode(true));
          });

          // Check for next page
          var newLoadMore = doc.querySelector('[data-load-more]');
          if (newLoadMore) {
            btn.dataset.nextUrl = newLoadMore.dataset.nextUrl;
            btn.classList.remove('fcg__load-more--loading');
            btn.innerHTML = 'Load More Products <span class="fcg__load-more-count">' +
              newLoadMore.querySelector('.fcg__load-more-count')?.textContent || '' +
              '</span>';
          } else {
            btn.remove();
          }

          // Update URL without reload
          history.replaceState(null, '', nextUrl);

          // Re-init product card JS for new cards
          reinitCardJS();
        })
        .catch(function () {
          btn.classList.remove('fcg__load-more--loading');
          btn.textContent = 'Error — Try Again';
          setTimeout(function () {
            btn.innerHTML = 'Load More Products';
          }, 2000);
        });
    });
  }


  // ── Re-init card behaviors after load-more ──
  function reinitCardJS() {
    // Product card JS (filtrous-product-card.js) uses event delegation
    // on document, so new cards are automatically handled.
    // This function exists for any future non-delegated init.
  }

})();
